export class TicketInfo {
  constructor(peopleahead, ticketid, meetuplocation, ticketnumber, tickettime, cancelled)
  {
    var splitticketnumber = ticketnumber.split(/(\d+)/)
    this.peopleAhead = peopleahead;
    this.ticketID = ticketid;
    this.meetUpLocation = meetuplocation ? meetuplocation : ""; // What values will this take depending on Gala/NQC?
    this.timestamp = tickettime;
    this.ticketnumber = splitticketnumber[0].concat(splitticketnumber[1].padStart(3,'0'));
    this.cancelled = cancelled || false; // This should be set to true when canceled manually or if it's older than one day
  }
}